// import { sectionFull, sectionHalf, sectionStory } from "./sections";
import {
  componentAnimation,
  componentAccordion,
  componentCounterGrid,
} from "./components";
// core version + navigation, pagination modules:
import Swiper from "swiper";
import { Navigation, Pagination, Autoplay, Keyboard } from "swiper/modules";

import * as NavNavigation from "./navigation.js";
import * as Modal from "./modal.js";
import * as Forms from "./forms.js";


NavNavigation.menuToggle();
componentAnimation();
componentAccordion();
componentCounterGrid();

// Slider main
var slider = document.querySelector(".slider");

if (slider) {
  var swiperSlider = new Swiper(".slider .swiper-container", {
	modules: [Navigation, Pagination, Autoplay, Keyboard],
    slidesPerView: "auto",
    loop: true,
    keyboard: {
      enabled: true
    },
    pagination: {
      el: ".slider__pagination",
      type: "progressbar",
    },
    navigation: {
      nextEl: ".slider__next",
      prevEl: ".slider__prev",
    },
        // Barrierefreiheit: aria-hidden setzen
on: {
  init: function () {
    document.querySelectorAll(".swiper-slide").forEach((slide) => {
      slide.setAttribute("aria-hidden", "true");
      slide.setAttribute("inert", "");
    });

    const active = document.querySelector(".swiper-slide-active");
    if (active) {
      active.setAttribute("aria-hidden", "false");
      active.removeAttribute("inert");
    }

    console.log("Swiper initialized");
  },
  slideChange: function () {
    document.querySelectorAll(".swiper-slide").forEach((slide) => {
      slide.setAttribute("aria-hidden", "true");
      slide.setAttribute("inert", "");
    });

    setTimeout(() => {
      const active = document.querySelector(".swiper-slide-active");
      if (active) {
        active.setAttribute("aria-hidden", "false");
        active.removeAttribute("inert");
      }

      const liveRegion = document.getElementById("SwiperLive");
      if (liveRegion) {
        liveRegion.textContent =
          "Slide " + (swiperSlider.realIndex + 1) + " displayed";
      }
    }, 0);
  },
},

  });

  var slideActive = document.querySelector(".slider__statestart");
  var slideEnd = document.querySelector(".slider__stateend");
  if (slideActive && slideEnd) {
    var slideMin = swiperSlider.realIndex + 1;
    // var slideMax = swiperSlider.activeIndex;
    var slideMax = swiperSlider.slides.length;

    slideActive.innerHTML = "0" + slideMin;
    slideEnd.innerHTML = "0" + slideMax;
    // console.log(slideMax)

    swiperSlider.on("slideChange", function () {
      var slideMin = swiperSlider.realIndex + 1;
      slideActive.innerHTML = "0" + slideMin;      
    });
  }
}

// Mobile Height Hack
const mobileHeight = () => {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
};

mobileHeight();

window.addEventListener("resize", () => {
  mobileHeight();
});
